import { Draft } from '@reduxjs/toolkit';

export const pendingReducer = (state: Draft<{ isLoading: boolean }>) => {
  state.isLoading = true;
};

export const rejectedReducer = (state: Draft<{ isLoading: boolean }>) => {
  state.isLoading = false;
};
